import { Apis } from "../../../lib/Apis";

export const popularHouseDesign = () => {
    const addPopularHouseDesing = async (data) => {
        try {
            const respsone = await Apis.addPopularHouseDesign(data);
            return respsone.data
        } catch (error) {
            console.error(error);
        }
    }
    const getAllHouseDesing = async (setHouseDesignData) => {
        try {
            const respsone = await Apis.getAllHouseDesignNames();
            setHouseDesignData(respsone.data);
            return respsone.data.data
        } catch (error) {
            console.error(error);
            return error
        }
    }
    return {
        addPopularHouseDesing,
        getAllHouseDesing
    }
}